import {
  IonButton,
  IonButtons,
  IonContent,
  IonHeader,
  IonIcon,
  IonPage,
  IonSegment,
  IonTitle,
  IonToolbar,
  useIonViewDidLeave,
  useIonViewWillEnter,
} from '@ionic/react'
import { useDispatch, useSelector } from 'react-redux'
import './Timeline.page.css'
import { IRootState } from '../../../store'
import React, { BaseSyntheticEvent, useEffect } from 'react'
import { IonSegmentButton, IonLabel } from '@ionic/react'
import { TimelineConstants } from '../store/timeline.constants'
import TimelineSection from '../timelineSection/timelineSection.component'
import TripInformationSection from '../tripInformationSection/tripInformationSection.component'
import TimelineHeaderComponent from '../timelineHeader/timelineHeader.component'
import { chevronBackOutline } from 'ionicons/icons'
import { useTranslation } from 'react-i18next'
import { useHistory } from 'react-router'
import { TabConstants } from '../../../components/tabs/Tabs.constants'
import PCRHeader from '../../../components/pcrHeader/PCRHeader.component'
import {
  setDeleteParentVitals,
  setDeleteVitalsPrompt,
  setSegment,
  setIsEditMode,
  setDeleteProcedurePrompt,
  setDeleteProcedure,
} from '../store/timeline.actions'
import { showAlert } from '../../../components/alert/store/alert.actions'

const Timeline: React.FC = () => {
  const dispatch = useDispatch()

  const { t } = useTranslation()
  const history = useHistory()

  const timeline = useSelector((state: IRootState) => state.timeline)
  const { segment, deleteVitalsPrompt, selectedItem, deleteProcedurePrompt } = timeline

  const onBackClick = (e: BaseSyntheticEvent) => {
    e.preventDefault()
    history.push(TabConstants.CHART_ROUTE)
  }

  useIonViewDidLeave(() => {
    dispatch(setSegment('Timeline'))
    dispatch(setIsEditMode(false))
  })

  useIonViewWillEnter(() => {
    dispatch(setIsEditMode(false))
  })

  useEffect(() => {
    if (deleteProcedurePrompt) {
      dispatch(
        showAlert({
          message:
            selectedItem?.event === 'Vitals'
              ? t('timeline.deleteVitalWithCustomDataWarning')
              : t('timeline.deleteProcedureWarning'),
          buttons: [
            {
              text: t('common.buttons.No'),
            },
            {
              text: t('common.buttons.Yes'),
              role: 'destructive',
              handler: handleDeleteContinue,
            },
          ],
        })
      )
      dispatch(setDeleteProcedurePrompt(false))
    }
  }, [deleteProcedurePrompt])

  useEffect(() => {
    if (deleteVitalsPrompt) {
      dispatch(
        showAlert({
          message: t('timeline.deleteWarning'),
          buttons: [
            {
              text: t('common.buttons.No'),
            },
            {
              text: t('common.buttons.Yes'),
              role: 'destructive',
              handler: handleDeleteContinue,
            },
          ],
        })
      )
      dispatch(setDeleteVitalsPrompt(false))
    }
  }, [deleteVitalsPrompt])

  const handleDeleteContinue = () => {
    dispatch(setDeleteParentVitals(true))
    dispatch(setDeleteProcedure(true))
    dispatch({ type: TimelineConstants.DELETE_TIMELINE_ITEM, payload: selectedItem })
  }

  return (
    <IonPage>
      <PCRHeader />
      <IonHeader>
        <IonToolbar color='light'>
          <IonButtons slot='start'>
            <IonButton data-testid='Back' onClick={onBackClick} color='primary-alt'>
              <IonIcon icon={chevronBackOutline} />
              {t('common.buttons.Back')}
            </IonButton>
          </IonButtons>
          <IonTitle>Activity Log</IonTitle>
        </IonToolbar>
        <IonToolbar color='light'>
          <IonSegment
            color='dark'
            className='segment-bottom-padding'
            value={segment}
            onIonChange={(e) =>
              dispatch({
                type: TimelineConstants.SET_SEGMENT,
                segment: e.detail.value,
              })
            }>
            <IonSegmentButton data-testid='TripInformationSegment' value={'Summary'}>
              <IonLabel>{t('timeline.Summary')}</IonLabel>
            </IonSegmentButton>

            <IonSegmentButton data-testid='TimelineSegment' value={'Timeline'}>
              <IonLabel>{t('timeline.Timeline')}</IonLabel>
            </IonSegmentButton>
          </IonSegment>
        </IonToolbar>
        {segment === 'Timeline' && <TimelineHeaderComponent />}
      </IonHeader>

      <IonContent fullscreen color='light'>
        {segment === 'Summary' && <TripInformationSection />}

        {segment === 'Timeline' && <TimelineSection isPHI />}
      </IonContent>
    </IonPage>
  )
}

export default Timeline
